import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_segment_line_RowClass } from '../../../dbschema/bl_dgmkt_segment_lines.model';

export class SegmentLineContainerModel extends BaseContainerModel {
    bl_dgmkt_segment_line: bl_dgmkt_segment_line_RowClass = new bl_dgmkt_segment_line_RowClass();
}